module.exports = __webpack_public_path__ + "img/icon-close_white.b26fa5c6.svg";